import { render, staticRenderFns } from "./GruppoView.vue?vue&type=template&id=08515f9e"
import script from "./GruppoView.vue?vue&type=script&lang=js"
export * from "./GruppoView.vue?vue&type=script&lang=js"
import style0 from "./GruppoView.vue?vue&type=style&index=0&id=08515f9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports